import { render, staticRenderFns } from "./timetable.vue?vue&type=template&id=533cf7f5&"
import script from "./timetable.vue?vue&type=script&lang=js&"
export * from "./timetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports